import React from 'react';
import PropTypes from 'prop-types';
import {
  NavLink,
  Route,
} from 'react-router-dom';

import ViolinPlot from '../containers/SingleCell/ViolinPlot';
import ViolinPlotResults from './SingleCell/ViolinPlotResults';
import HeatMap from '../containers/SingleCell/HeatMap';
import HeatMapResults from './SingleCell/HeatMapResults';
import VolcanoPlot from './SingleCell/VolcanoPlot';
import VolcanoPlotResults from './SingleCell/VolcanoPlotResults';

import singleCellImage from '../images/singlecell.png';

import './SingleCell.css';


class SingleCell extends React.Component {
  render() {
    const { match } = this.props;
    return (
      <div className="container singlecell dataset">
        <div className="row">
          <div className="col">
            <h2>Single Cell Data set</h2>
          </div>
        </div>

        <div className="row">
          <div className="col">
            <img alt="Single cell atlas" src={singleCellImage} />
          </div>
        </div>

        <div className="row">
          <div className="col">
            <div className="card">
              <div className="card-header">
                Perform Analysis.
              </div>
              <div className="card-body">

                <ul className="nav nav-tabs">
                  <li className="nav-item">
                    <NavLink className="nav-link" to={`${match.url}/violin`}>Violin Plot</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to={`${match.url}/heatmap`}>Heatmap</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to={`${match.url}/volcano`}>Volcano Plot</NavLink>
                  </li>
                </ul>

                <Route path={`${match.url}/violin`} component={ViolinPlot} />
                <Route path={`${match.url}/heatmap`} component={HeatMap} />
                <Route path={`${match.url}/volcano`} component={VolcanoPlot} />
              </div>
            </div>
          </div>
        </div>
        <Route path={`${match.url}/heatmap/:hash`} component={HeatMapResults} />
        <Route path={`${match.url}/violin/:hash`} component={ViolinPlotResults} />
        <Route path={`${match.url}/volcano/:hash`} component={VolcanoPlotResults} />

      </div>
    );
  }
}

SingleCell.propTypes = {
  match: PropTypes.object.isRequired,
};


export default SingleCell;



// WEBPACK FOOTER //
// ./src/components/SingleCell.jsx